// DO NOT EDIT -- generated from fs/services/dx-objects/heatmaps.proto

import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';

export namespace HeatmapsPublic {

  export const GetAllHeatmapsEndpoint = "/grpc/dx_objects.HeatmapsPublic/GetAllHeatmaps";
  /** Gets all heatmaps */
  export function GetAllHeatmaps(sender: (req: GetAllHeatmapsRequest, endpoint: string) => Promise<GetAllHeatmapsResponse>, req: GetAllHeatmapsRequest): { promise: () => Promise<GetAllHeatmapsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllHeatmapsEndpoint),
      endpoint: GetAllHeatmapsEndpoint
    };
  }

  export const GetHeatmapEndpoint = "/grpc/dx_objects.HeatmapsPublic/GetHeatmap";
  /** Get a specific funnel at the current version. */
  export function GetHeatmap(sender: (req: GetHeatmapRequest, endpoint: string) => Promise<GetHeatmapResponse>, req: GetHeatmapRequest): { promise: () => Promise<GetHeatmapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetHeatmapEndpoint),
      endpoint: GetHeatmapEndpoint
    };
  }

  export const SetHeatmapEndpoint = "/grpc/dx_objects.HeatmapsPublic/SetHeatmap";
  /** Sets a heatmap */
  export function SetHeatmap(sender: (req: SetHeatmapRequest, endpoint: string) => Promise<HeatmapDetail>, req: SetHeatmapRequest): { promise: () => Promise<HeatmapDetail>, endpoint: string } {
    return {
      promise: () => sender(req, SetHeatmapEndpoint),
      endpoint: SetHeatmapEndpoint
    };
  }

  export const MarkHeatmapViewedEndpoint = "/grpc/dx_objects.HeatmapsPublic/MarkHeatmapViewed";
  /** Updates the LastViewed timestamp for a heatmap */
  export function MarkHeatmapViewed(sender: (req: MarkHeatmapViewedRequest, endpoint: string) => Promise<{}>, req: MarkHeatmapViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkHeatmapViewedEndpoint),
      endpoint: MarkHeatmapViewedEndpoint
    };
  }

  export const StarHeatmapEndpoint = "/grpc/dx_objects.HeatmapsPublic/StarHeatmap";
  /** Stars/unstars a heatmap */
  export function StarHeatmap(sender: (req: StarHeatmapRequest, endpoint: string) => Promise<{}>, req: StarHeatmapRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StarHeatmapEndpoint),
      endpoint: StarHeatmapEndpoint
    };
  }

  export const ArchiveHeatmapEndpoint = "/grpc/dx_objects.HeatmapsPublic/ArchiveHeatmap";
  /** Archives/unarchives a heatmap */
  export function ArchiveHeatmap(sender: (req: ArchiveHeatmapRequest, endpoint: string) => Promise<ArchiveHeatmapResponse>, req: ArchiveHeatmapRequest): { promise: () => Promise<ArchiveHeatmapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveHeatmapEndpoint),
      endpoint: ArchiveHeatmapEndpoint
    };
  }

  export const BulkArchiveHeatmapsEndpoint = "/grpc/dx_objects.HeatmapsPublic/BulkArchiveHeatmaps";
  export function BulkArchiveHeatmaps(sender: (req: BulkArchiveHeatmapsRequest, endpoint: string) => Promise<BulkArchiveHeatmapsResponse>, req: BulkArchiveHeatmapsRequest): { promise: () => Promise<BulkArchiveHeatmapsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveHeatmapsEndpoint),
      endpoint: BulkArchiveHeatmapsEndpoint
    };
  }

  export const CreateUnnamedHeatmapEndpoint = "/grpc/dx_objects.HeatmapsPublic/CreateUnnamedHeatmap";
  export function CreateUnnamedHeatmap(sender: (req: CreateUnnamedHeatmapRequest, endpoint: string) => Promise<{}>, req: CreateUnnamedHeatmapRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedHeatmapEndpoint),
      endpoint: CreateUnnamedHeatmapEndpoint
    };
  }

  export const GetUnnamedHeatmapEndpoint = "/grpc/dx_objects.HeatmapsPublic/GetUnnamedHeatmap";
  export function GetUnnamedHeatmap(sender: (req: GetUnnamedHeatmapRequest, endpoint: string) => Promise<GetUnnamedHeatmapResponse>, req: GetUnnamedHeatmapRequest): { promise: () => Promise<GetUnnamedHeatmapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedHeatmapEndpoint),
      endpoint: GetUnnamedHeatmapEndpoint
    };
  }

  export const GetHeatmapsAccessEndpoint = "/grpc/dx_objects.HeatmapsPublic/GetHeatmapsAccess";
  export function GetHeatmapsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetHeatmapsAccessEndpoint),
      endpoint: GetHeatmapsAccessEndpoint
    };
  }
}

/** HeatmapsAdmin provides administrative operations for heatmaps that are restricted to Fullstory internal users */
export namespace HeatmapsAdmin {

  export const CopyHeatmapsToOrgEndpoint = "/grpc/dx_objects.HeatmapsAdmin/CopyHeatmapsToOrg";
  /**
   * CopyHeatmapsToOrg copies heatmaps from one org to another
   * Only accessible to Fullstory internal users
   */
  export function CopyHeatmapsToOrg(sender: (req: CopyHeatmapsToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopyHeatmapsToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopyHeatmapsToOrgEndpoint),
      endpoint: CopyHeatmapsToOrgEndpoint
    };
  }
}

/**
 * HeatmapDetail is the seat's view of a saved Heatmap.
 * It contains the heatmap definition, audit metadata,
 * and seat-level settings such as starred, last viewed timestamp, etc.
 */
export interface HeatmapDetail {
  heatmap: search_settings.HeatmapRecord | null;
  /** Whether the seat in the request has starred the heatmap */
  starred: boolean;
  /** When the seat in the request last viewed the heatmap */
  lastViewed: protobuf.timestamp | null;
}

export interface GetAllHeatmapsRequest {
  orgId: string;
  /** If true, archived Heat maps will also be returned. */
  includeArchived: boolean;
}

export interface GetAllHeatmapsResponse {
  heatmaps: HeatmapDetail[];
}

export interface GetHeatmapRequest {
  orgId: string;
  heatmapId: string;
}

export interface GetHeatmapResponse {
  heatmap: HeatmapDetail | null;
}

export interface SetHeatmapRequest {
  orgId: string;
  heatmap: search_settings.Heatmap | null;
  visibility: protoauditstore.Visibility;
}

export interface MarkHeatmapViewedRequest {
  orgId: string;
  heatmapId: string;
}

export interface StarHeatmapRequest {
  orgId: string;
  heatmapId: string;
  /** True to star, false to unstar */
  starred: boolean;
}

export interface ArchiveHeatmapRequest {
  orgId: string;
  heatmapId: string;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveHeatmapResponse {
  heatmap: HeatmapDetail | null;
}

export interface BulkArchiveHeatmapsRequest {
  orgId: string;
  heatmaps: ArchiveHeatmapRequest[];
}

export interface BulkArchiveHeatmapsResponse {
  heatmaps: MaybeHeatmapDetail[];
}

export interface MaybeHeatmapDetail {
  heatmapId: string;
  failed?: boolean;
  heatmap?: HeatmapDetail | null;
}

export namespace MaybeHeatmapDetail {
  export enum failed_or_heatmap {
    failed = 2,
    heatmap = 3
  }

  export function failed_or_heatmap_oneof(m: MaybeHeatmapDetail): { opt: failed_or_heatmap.failed, val: boolean } | { opt: failed_or_heatmap.heatmap, val: HeatmapDetail } | null {
    if (m.failed != null) { return { opt: failed_or_heatmap.failed, val: m.failed } }
    if (m.heatmap != null) { return { opt: failed_or_heatmap.heatmap, val: m.heatmap } }
    return null;
  }
}

export interface UnnamedHeatmap {
  heatmap: search_settings.Heatmap | null;
}

export interface CreateUnnamedHeatmapRequest {
  hash: string;
  heatmap: UnnamedHeatmap | null;
}

export interface GetUnnamedHeatmapRequest {
  hash: string;
}

export interface GetUnnamedHeatmapResponse {
  hash: string;
  heatmap: UnnamedHeatmap | null;
}

/** Request message for copying heatmaps from one org to another */
export interface CopyHeatmapsToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  heatmapIds: string[];
  /** Mapping of segment IDs from source to destination */
  segmentMappings: { [key: string]: string };
}
